export default __webpack_public_path__ + "static/FSF_logo-a1f502b5a5953bf59744c8cd1f78327e.png";